var _path, _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6306_29062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50001 6C5.21668 6 4.97901 5.90433 4.78701 5.713C4.59568 5.521 4.50001 5.28333 4.50001 5C4.50001 4.71667 4.59568 4.479 4.78701 4.287C4.97901 4.09567 5.21668 4 5.50001 4H19.5C19.7833 4 20.0207 4.09567 20.212 4.287C20.404 4.479 20.5 4.71667 20.5 5C20.5 5.28333 20.404 5.521 20.212 5.713C20.0207 5.90433 19.7833 6 19.5 6H5.50001ZM5.50001 20C5.21668 20 4.97901 19.904 4.78701 19.712C4.59568 19.5207 4.50001 19.2833 4.50001 19V14H4.32501C4.00835 14 3.75001 13.879 3.55001 13.637C3.35001 13.3957 3.28335 13.1167 3.35001 12.8L4.35001 7.8C4.40001 7.56667 4.51668 7.375 4.70001 7.225C4.88335 7.075 5.09168 7 5.32501 7H19.675C19.9083 7 20.1167 7.075 20.3 7.225C20.4833 7.375 20.6 7.56667 20.65 7.8L21.65 12.8C21.7167 13.1167 21.65 13.3957 21.45 13.637C21.25 13.879 20.9917 14 20.675 14H20.5V19C20.5 19.2833 20.404 19.5207 20.212 19.712C20.0207 19.904 19.7833 20 19.5 20C19.2167 20 18.9793 19.904 18.788 19.712C18.596 19.5207 18.5 19.2833 18.5 19V14H14.5V19C14.5 19.2833 14.4043 19.5207 14.213 19.712C14.021 19.904 13.7833 20 13.5 20H5.50001ZM6.50001 18H12.5V14H6.50001V18Z",
    fill: "#CD3438"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6306_29062)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#CD3438"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6306_29062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6306_29062)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    transform: "matrix(-1 0 0 1 41.5 -17)",
    fill: "url(#paint0_linear_6306_29062)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6306_29062",
    x1: 34,
    y1: 0,
    x2: -2.69152e-7,
    y2: 36.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.2e08fec4bfbfaa47daa1c6f139a31d46.svg";
export { ForwardRef as ReactComponent };